<app-blog-shell [blogId]="'dark-light-mode'" [darkMode]="darkMode">
  <div #entryRoot class="blog-entry">
    <h1 data-translate="BLOG.DETAILS.dark-light-mode.TITLE"></h1>
    <br>

    <p data-translate="BLOG.DETAILS.dark-light-mode.INTRO.P1"></p>
    <p data-translate="BLOG.DETAILS.dark-light-mode.INTRO.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.dark-light-mode.TLDR.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.dark-light-mode.TLDR.BODY"></p>
    <ul>
      <li data-translate="BLOG.DETAILS.dark-light-mode.TLDR.LI1"></li>
      <li data-translate="BLOG.DETAILS.dark-light-mode.TLDR.LI2"></li>
    </ul>

    <br><br>
    <h2 data-translate="BLOG.DETAILS.dark-light-mode.SECTION1.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.dark-light-mode.SECTION1.P1"></p>
    <p data-translate="BLOG.DETAILS.dark-light-mode.SECTION1.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.dark-light-mode.SECTION2.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.dark-light-mode.SECTION2.P1"></p>
    <p data-translate="BLOG.DETAILS.dark-light-mode.SECTION2.P2"></p>

    <pre ngNonBindable>
  <code class="language-typescript">
    initializeDarkContainers() &#123;
      const pages = ['home','about','resume','portfolio','blog','contact'];

      pages.forEach(page =&gt; &#123;
        const box = document.querySelector('.box') as HTMLElement;
        if (!box) return;

        if (!document.querySelector('#dark-container-' + page)) &#123;
          const clone = (box
            .querySelector('.face.' + page) as HTMLElement)
            .querySelector('.section.' + page)
            .cloneNode(true) as HTMLElement;

          clone.id = 'dark-container-' + page;
          clone.classList.remove('active');  // Dark-Zwilling startet passiv
          (box.querySelector('.face.' + page) as HTMLElement).appendChild(clone);
        &#125;
      &#125;);

      ['imprintOverlay','privacyPolicyOverlay'].forEach(id =&gt; &#123;
        const el = document.getElementById(id);
        if (!el || document.getElementById('dark-container-' + id)) return;

        const clone = el.cloneNode(true) as HTMLElement;
        clone.id = 'dark-container-' + id;
        clone.classList.remove('visible');
        document.body.appendChild(clone);
      &#125;);

      this.addDarkContainerListeners();

      // Beispiel für Dark-spezifisches Asset
      const img = document.querySelector('#dark-container-home .home-img img') as HTMLImageElement;
      if (img) img.src = 'home/hero_dark.webp';
    &#125;
  </code>
</pre>

    <p data-translate="BLOG.DETAILS.dark-light-mode.SECTION2.P3"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.dark-light-mode.SECTION3.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.dark-light-mode.SECTION3.P1"></p>
    <p data-translate="BLOG.DETAILS.dark-light-mode.SECTION3.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.dark-light-mode.SECTION4.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.dark-light-mode.SECTION4.P1"></p>

    <pre ngNonBindable>
      <code class="language-css">
#dark-container-home &#123;
  clip-path: circle(0% at 50% 50%);
  transition: clip-path 1s ease-in-out;
&#125;

.dark-mode-active #dark-container-home &#123;
  clip-path: circle(150% at 50% 50%);
&#125;
      </code>
    </pre>

    <p data-translate="BLOG.DETAILS.dark-light-mode.SECTION4.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.dark-light-mode.SECTION5.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.dark-light-mode.SECTION5.P1"></p>
    <p data-translate="BLOG.DETAILS.dark-light-mode.SECTION5.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.dark-light-mode.SECTION6.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.dark-light-mode.SECTION6.P1"></p>
    <p data-translate="BLOG.DETAILS.dark-light-mode.SECTION6.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.dark-light-mode.CONCLUSION.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.dark-light-mode.CONCLUSION.P1"></p>
    <p data-translate="BLOG.DETAILS.dark-light-mode.CONCLUSION.P2"></p>
  </div>
  <br>
</app-blog-shell>
